const colors = {
  blue: {
    200: '#D4D6DA',
    400: '#A5ACB5',
    500: '#223044',
    600: '#79838F',
    800: '#4D596A'
  },
  gold: {
    200: '#ECE7D6',
    400: '#D9CFAD',
    500: '#A18732',
    600: '#C7B784',
    800: '#B49F5B'
  },
  primary: {
    200: '#CAD9F2',
    400: '#98B5E1',
    500: '#0A4A8D',
    600: '#6591CA',
    800: '#336EAE'
  },
  secondary: {
    200: '#B3E2FB',
    400: '#93D2F4',
    500: '#499CC9',
    600: '#77C1E9',
    800: '#5EAFDB'
  },
  tertiary: {
    200: '#BDF9FF',
    400: '#A4F4FF',
    500: '#6ED8FF',
    600: '#8EECFF',
    800: '#7CE3FF'
  },
  lightGray: {
    50: '#FAFAFA',
    200: '#FAFAFA',
    300: '#757575',
    400: '#F5F5F5',
    500: '#BDBDBD',
    600: '#EEEEEE',
    800: '#E0E0E0'
  },
  darkGray: {
    200: '#9E9E9E',
    400: '#757575',
    500: '#212121',
    600: '#616161',
    800: '#424242'
  },
  white: {
    500: '#FFFFFF'
  },
  success: {
    200: '#D9EFE9',
    400: '#03906A',
    500: '#03906A',
    600: '#005F44'
  },
  error: {
    200: '#FBE1E1',
    400: '#CC3736',
    500: '#CC3736',
    600: '#841E1D'
  },
  warning: {
    200: '#FFE9CA',
    400: '#D68612',
    500: '#D68612',
    600: '#D68612',
    800: '#8C5505'
  },
  text: {
    50: '#222A34'
  }
};
export { colors };
//# sourceMappingURL=index.js.map